import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import { NumberFormatter } from '../../utils/Intl';
import { Button, Divider } from '@homeexchange/design';

export default class ButtonsGuestpoints extends React.Component {
    static propTypes = {
        manageGuestpoints: PropTypes.func.isRequired,
        conversation: PropTypes.instanceOf(Conversation).isRequired
    };

    constructor(props) {
        super(props);
        this.handleKeepGuestpoints = this.handleKeepGuestpoints.bind(this);
        this.handleGivebackGuestpoints = this.handleGivebackGuestpoints.bind(this);

        this.state = {
            keepGPIsDisabled: false,
            givebackGPIsDisabled: false
        };
    }

    render() {
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        const bothExchangesWasFinalized = this.props.conversation.isFinalized();

        if (exchangeAsHost && bothExchangesWasFinalized && exchangeAsHost.hasToHandleGuestpoints()) {
            return (
                <>
                    <Divider space="no" />
                    <Button
                        size="medium"
                        hierarchy="secondary"
                        isDisabled={this.state.keepGPIsDisabled}
                        onClick={this.handleKeepGuestpoints}
                        isFullWidth
                    >
                        {i18n.t('exchange:action_keep_guestpoints')}
                    </Button>
                    <Button
                        size="medium"
                        hierarchy="secondary"
                        isDisabled={this.state.givebackGPIsDisabled}
                        onClick={this.handleGivebackGuestpoints}
                        isFullWidth
                    >
                        {i18n.t('exchange:action_giveback_guestpoints')}
                    </Button>
                </>
            );
        }

        return false;
    }

    handleKeepGuestpoints(event) {
        event.preventDefault();
        // disable button
        const button = event.target;
        this.setState({
            keepGPIsDisabled: true
        });
        // $(button).addClass('sending');
        // confirm
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        sweetAlert({
            icon: 'warning',
            title: i18n.t('exchange:guestpoints_keep_confirm_title'),
            text: i18n.t('exchange:guestpoints_keep_confirm_text', {
                value: NumberFormatter.format(exchangeAsHost.getGpTotal()),
                first_name: exchangeAsHost.get('guest').get('first_name')
            }),
            buttons: {
                cancel: {
                    text: i18n.t('common:cancel'),
                    visible: true
                },
                confirm: {
                    text: i18n.t('common:continue'),
                    closeModal: false
                }
            }
        }).then((isConfirm) => {
            if (isConfirm) {
                // keep guestpoints
                this.props
                    .manageGuestpoints(this.props.conversation.id, false)
                    .always(() => {
                        sweetAlert.close();
                        $(button).removeClass('sending');
                    })
                    .fail(() => {
                        this.setState({
                            keepGPIsDisabled: false
                        });
                    });
            } else {
                $(button).removeClass('sending');
                this.setState({
                    keepGPIsDisabled: false
                });
            }
        });
    }

    handleGivebackGuestpoints(event) {
        event.preventDefault();
        // disable button
        const button = event.target;
        this.setState({
            givebackGPIsDisabled: true
        });
        // $(button).addClass('sending');
        // confirm
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        sweetAlert({
            icon: 'warning',
            title: i18n.t('exchange:guestpoints_giveback_confirm_title'),
            text: i18n.t('exchange:guestpoints_giveback_confirm_text', {
                value: NumberFormatter.format(exchangeAsHost.getGpTotal()),
                first_name: exchangeAsHost.get('guest').get('first_name')
            }),
            buttons: {
                cancel: {
                    text: i18n.t('common:cancel'),
                    visible: true
                },
                confirm: {
                    text: i18n.t('common:continue'),
                    closeModal: false
                }
            }
        }).then((isConfirm) => {
            if (isConfirm) {
                // giveback guestpoints
                this.props
                    .manageGuestpoints(this.props.conversation.id, true)
                    .always(() => {
                        sweetAlert.close();
                        $(button).removeClass('sending');
                    })
                    .fail(() => {
                        this.setState({
                            givebackGPIsDisabled: false
                        });
                    });
            } else {
                $(button).removeClass('sending');
                this.setState({
                    givebackGPIsDisabled: false
                });
            }
        });
    }
}
